import { Form } from 'react-bootstrap';

const TextInput = ({
  label,
  name,
  value,
  onChange,
  className,
  labelClassName,
  inputClassName,
  placeholder,
  password,
  required,
}) => (
  <div className={className}>
    {label && (
    <Form.Label className={labelClassName}>
      {label}
      {required && <span className="text-primary"> *</span>}
    </Form.Label>
    )}
    <div>
      <Form.Control
        name={name}
        // id="input"
        type={password ? 'password' : ''}
        value={value}
        className={inputClassName}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  </div>
);

export default TextInput;
